import { ReactNode, useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

interface AutoRefreshingRouterProps {
  children: ReactNode;
}

export const AutoRefreshingRouter = ({
  children,
}: AutoRefreshingRouterProps) => {
  const [shouldRefresh, setShouldRefresh] = useState(false);

  useEffect(() => {
    const refreshPeriodInMs = 1000 * 60 * 60 * 6; // 6 hours

    const id = setTimeout(() => setShouldRefresh(true), refreshPeriodInMs);
    return () => clearTimeout(id);
  }, []);

  return (
    <BrowserRouter key={shouldRefresh ? 1 : 2} forceRefresh={shouldRefresh}>
      {children}
    </BrowserRouter>
  );
};
